import ProfilePic from '../Assets/ProfilePic.jpeg'
let ProfileData = {
    Nome: "João Gabriel de Campos de Matos",
    Email: "joao.matos@orcestra.com.br",
    Telefone: "(61) 9XXXX-XXX",
    SobreMim: ['Graduando em Engenharia de Software.','Interessado em desenvolvimento web e ciência de dados.',"Atualmente sou trainee na Orc'estra Gamificação (Empresa Júnior de Gamificação da UnB)."],
    ProfilePic: {
        src: ProfilePic,
        alt: "Placeholder temporario"
    }
}
// https://static.wixstatic.com/media/0f860c_7c5bb1fa5ff245e6873fc83fbbd4b84f~mv2.png/v1/fill/w_575,h_537,al_c,q_85,usm_0.66_1.00_0.01/final2duck.webp
export default ProfileData